<app-table [data]="toolsGrouped"
           [config]="tableConfig"
           [treeMode]="true"
           [rowExpand]="false"
           [isLoading]="isLoading"
           [showFilters]="showFilters"
           [isFilterExpanded]="false"
           [showGroupFilters]="false"
           [groupFilters]="groupFilters"
           [showGroupers]="showGroupers"
           [groupableColumns]="groupableColumns"
           [directlyGrouped]="false"
           [displayToggleFilters]="false"
           [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
           [hasTitle]="hasTitle"
           [isMaterial]="isMaterial"
           [allExpanded]="allExpanded"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (filterGroupChange)="onFilterGroupChange($event)"
           (groupChange)="onGroupChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.tools.table.columns.toolName' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolName' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="name">
        <ng-template #body
                     let-record="record">
            <div class="tool-select">
                <input type="checkbox"
                       (click)="onClickTool($event, record)"
                       *ngIf="hasCheckbox(record)"
                       [checked]="isChecked(record)"
                       [disabled]="isSelectionDisabled(record)"/>
                <span>{{ record.name }}</span>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolUid' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolUid' | translate}}"
                      sortable="true"
                      filter="true"
                      field="toolUid">
        <ng-template #body
                     let-record="record">
            <div [class.tool-set]="isToolSet(record)">
                {{ isToolSet(record) ? 'SET' : record.toolUid }}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.toolsUsage.table.columns.line' | translate}}"
                      filterPlaceholder="{{'admin.toolsUsage.table.filters.line' | translate}}"
                      sortable="true"
                      filter="true"
                      field="line">
        <ng-template #body
                     let-record="record">
            {{record?.mainLine?.name}}
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.details.header.details-labels.cart' | translate}}"
                      filterPlaceholder="{{'admin.toolsUsage.table.filters.cart' | translate}}"
                      sortable="true"
                      filter="true"
                      field="cart">
        <ng-template #body
                     let-record="record">
            {{record?.cart}}
        </ng-template>
    </app-table-column>
</app-table>
